import { Navigate } from 'react-router-dom';

import { NavigateWithParams } from '@spacefill/shared/src/utils/RouterUtils';

const LogisticManagementStockAdjustmentByWarehouse = async () =>
    import('../../pages/inventory/stock-situation/StockAdjustment').then((module) => ({
        Component: module.LogisticManagementStockAdjustmentByWarehouse,
    }));

const LogisticManagementAccurateStockSituation = async () =>
    import('../../pages/inventory/accurate-stock-situation/index').then((module) => ({
        Component: module.LogisticManagementAccurateStockSituation,
    }));

const getStockSituationRoutes = (user) => {
    return [
        {
            path: '/logistic-management/stock-situation/',
            lazy: LogisticManagementAccurateStockSituation,
        },
        {
            path: '/logistic-management/stock-situation/view/:viewId',
            lazy: LogisticManagementAccurateStockSituation,
        },
        {
            path: '/logistic-management/inventory/stock-situation/references/*',
            element: <Navigate to='/logistic-management/stock-situation/' />,
        },

        {
            path: '/logistic-management/warehouses/:warehouseId/stock-situation/',
            lazy: LogisticManagementAccurateStockSituation,
        },
        {
            path: '/logistic-management/warehouses/:warehouseId/stock-situation/view/:viewId',
            lazy: LogisticManagementAccurateStockSituation,
        },
        {
            path: '/logistic-management/warehouses/:warehouseId/inventory/stock-situation/references/*',
            element: (
                <NavigateWithParams
                    to={(params) => `/logistic-management/warehouses/${params.warehouseId}/stock-situation/`}
                />
            ),
        },

        // LSP specific
        {
            path: '/logistic-management/warehouses/:warehouseId/inventory/stock-situation/new-adjustment/',
            lazy: LogisticManagementStockAdjustmentByWarehouse,
            condition: user.role === 'PROVIDER',
        },
    ];
};

export { getStockSituationRoutes };
